import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Input } from "antd";
import { multiLanguage } from "../../hoc";
import { Button } from "../../components";

const FormItem = Form.Item;

@Form.create()
@multiLanguage()
export default class Newsletter extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    onSubmit: PropTypes.func
  };
  static defaultProps = {
    onSubmit: () => null
  }
  state = {
    submitting: false,
  };
  submit = async data => {
    const { submitting } = this.state;
    if (submitting) return false;
    this.setState({ submitting: true });
    // sendEmail({
    //   ...data,
    //   contactType: "contact"
    // });
    // notification.success({
    //   message: "Newsletter Signup Success"
    // });
    this.setState({ submitting: false });
    this.props.form.resetFields();
    this.props.onSubmit();
    return true;
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.submit(values);
      }
    });
  };
  render() {
    const { t } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="newsletter-form">
        <Form onSubmit={this.handleSubmit}>
          <FormItem>
            {getFieldDecorator("email", {
              rules: [
                {
                  type: "email",
                  message: t("This email is not valid email address")
                },
                {
                  required: true,
                  message: t("This field is required")
                }
              ]
            })(<Input placeholder={t("Your Email Address")} />)}
            <Button
              defaultStyle={{
                padding: "0 14px",
                textTransform: "capitalize",
                letterSpacing: "normal",
                fontWeight: "bold",
                fontSize: "12px",
                lineHeight: "32px"
              }}
              type="default"
            >
              {t("Submit")}
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Form/Newsletter.js